import { Button, Col, Form, Row, Section, TextInput } from 'ui';

type P = {
  email?: string;
  loading: boolean;
  onNavigateToPrimaryLogin: () => Promise<void>;
  onSubmit: (data: { email: string }) => void;
};

const ForgotPasswordForm = ({ email, loading, onNavigateToPrimaryLogin, onSubmit }: P) => {
  const [form] = Form.useForm();

  const onFinish = (data: { email: string }) => {
    onSubmit(data);
  };

  return (
    <Form className="forgot-password-form" form={form} initialValues={{ email }} onFinish={onFinish}>
      <TextInput
        input={{
          autoComplete: 'email',
        }}
        item={{
          label: 'Email',
          name: 'email',
          rules: [
            {
              type: 'email',
            },
            {
              required: true,
              whitespace: true,
            },
          ],
        }}
      />
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={loading} size="large" type="primary">
              Send reset link
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              onClick={async () => {
                await onNavigateToPrimaryLogin();
              }}
              size="large"
            >
              Back to Log in
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default ForgotPasswordForm;
